/* global fsgBuild */

import { createSelector } from 'reselect';
import * as bowser from 'bowser';
import compareVersions from 'compare-versions';
import { get } from 'lodash/fp';

const LOCKED = 3;

const unsupportedSelector = () => bowser.ucbrowser || (bowser.msie && bowser.version <= 9);

const lockedSelector = createSelector(
  get('user.isSignedIn'),
  get('user.currentUser.id_verified'),
  get('user.currentUser.status.id'),
  get('settings.enablePxc'),
  (isSignedIn, isVerified, statusId, isPxcEnabled) =>
    isSignedIn && !isVerified && statusId === LOCKED && !isPxcEnabled
);

const outdatedSelector = createSelector(
  get('ui.minVersion'),
  get('ui.minIOSAppVersion'),
  get('route.query'),
  get('settings.isNative'),
  (minVersion, minIOSAppVersion, query, isNative) => {
    const nativeApp = get('native-app', query);
    const updateVia = get('update-via', query);
    const timestamp = get('timestamp', query);

    if (isNative || (nativeApp === 'ios' && updateVia === 'appstore')) {
      return fsgBuild.VERSION && compareVersions(fsgBuild.VERSION, minIOSAppVersion) < 0;
    }
    return fsgBuild.VERSION && compareVersions(fsgBuild.VERSION, minVersion) < 0 && !timestamp;
  }
);

const claimPlaSelector = createSelector(
  get('user.isSignedIn'),
  get('user.currentUser.pla_claim'),
  (isSignedIn, plaClaim) => isSignedIn && plaClaim && plaClaim.claim_link
);

function getAlert(isUnsupported, isLocked, isOutdated, claimPla) {
  if (isUnsupported) {
    return 'unsupported';
  }
  if (isOutdated) {
    return 'version';
  }
  if (claimPla) {
    return 'claimPla';
  }

  return undefined;
}

const alertSelector = createSelector(
  unsupportedSelector,
  lockedSelector,
  outdatedSelector,
  claimPlaSelector,
  getAlert
);

export default alertSelector;
